import api from "./api";

export const login = async (email, password) => {
  try {
    const response = await api.post("/login", {
      email,
      password,
      app_type: 'web'
    });
    
    // If backend requires a second factor, surface that to the caller without storing tokens
    if (response.data && response.data.requires_2fa) {
      // Optionally store pending email to assist UX
      try { localStorage.setItem("pendingEmail", email); } catch {}
      return {
        requires_2fa: true,
        email: response.data.email,
        message: response.data.message || "Verification code sent"
      };
    }

    if (response.data && response.data.access_token) {
      localStorage.setItem("token", response.data.access_token);
      localStorage.setItem("role", response.data.role);
      if (response.data.user_id) {
        localStorage.setItem("user_id", response.data.user_id.toString());
      }
      return response.data;
    } else {
      throw new Error("Invalid response from server");
    }
  } catch (error) {
    // Same as 401/Incorrect password: api interceptor may pass new Error(backendMessage) for 403 (staff-only)
    const backendError = error.response?.data?.error ?? error.error;
    const msg = backendError || error.message || "Login failed";
    throw new Error(msg);
  }
};

// Verify the 2FA/verification code to complete login
export const verifyCode = async (email, code) => {
  try {
    const response = await api.post("/verify-code", { email, code });

    if (response.data && response.data.access_token) {
      localStorage.setItem("token", response.data.access_token);
      localStorage.setItem("role", response.data.role);
      if (response.data.user_id) {
        localStorage.setItem("user_id", response.data.user_id.toString());
      }
      return response.data;
    } else {
      throw new Error(response.data?.message || "Invalid verification response");
    }
  } catch (error) {
    const backendError = error.response?.data?.error || error.response?.data?.message;
    throw new Error(backendError || error.message || "Verification failed");
  }
};

export const logout = () => {
  // Clear all auth-related data
  localStorage.removeItem("token");
  localStorage.removeItem("role");
  // Redirect to login; keep under /portal in production
  const basePath = window.location.pathname.startsWith("/portal") ? "/portal" : "";
  window.location.href = basePath ? `${basePath}/` : "/";
};

export const getCurrentUser = () => {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  return token ? { token, role } : null;
};

export const isAuthenticated = () => {
  return !!localStorage.getItem("token");
};

export const getToken = () => {
  return localStorage.getItem("token");
};

export const getRole = () => {
  return localStorage.getItem("role");
};

// (Optional legacy endpoints verify-2fa/resend-2fa removed in favor of /verify-code)